<template>
  <b-navbar-nav class="ml-auto">
    <div class="message-box message-warn">【注意】管理品あり</div>
  </b-navbar-nav>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';

export default {
  mixins: [BaseComponent],
  methods: {
  },
};
</script>

<style scoped>
.message-box {
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
  text-align: center;
  font-size: small;
  display: inline-block;
  width: 15rem
}
.message-warn {
  background-color: red;
  color: white;
}
</style>
